var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingsIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SettingsRounded"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.5002 12C19.5002 11.77 19.4902 11.55 19.4702 11.32L21.3302 9.91C21.7302 9.61 21.8402 9.05 21.5902 8.61L19.7202 5.38C19.4702 4.94 18.9302 4.76 18.4702 4.96L16.3202 5.87C15.9502 5.61 15.5602 5.38 15.1502 5.19L14.8602 2.88C14.8002 2.38 14.3702 2 13.8702 2H10.1402C9.63015 2 9.20015 2.38 9.14015 2.88L8.85015 5.19C8.44015 5.38 8.05015 5.61 7.68015 5.87L5.53015 4.96C5.07015 4.76 4.53015 4.94 4.28015 5.38L2.41015 8.62C2.16015 9.06 2.27015 9.61 2.67015 9.92L4.53015 11.33C4.51015 11.55 4.50015 11.77 4.50015 12C4.50015 12.23 4.51015 12.45 4.53015 12.68L2.67015 14.09C2.27015 14.39 2.16015 14.95 2.41015 15.39L4.28015 18.62C4.53015 19.06 5.07015 19.24 5.53015 19.04L7.68015 18.13C8.05015 18.39 8.44015 18.62 8.85015 18.81L9.14015 21.12C9.20015 21.62 9.63015 22 10.1302 22H13.8602C14.3602 22 14.7902 21.62 14.8502 21.12L15.1402 18.81C15.5502 18.62 15.9402 18.39 16.3102 18.13L18.4602 19.04C18.9202 19.24 19.4602 19.06 19.7102 18.62L21.5802 15.39C21.8302 14.95 21.7202 14.4 21.3202 14.09L19.4602 12.68C19.4902 12.45 19.5002 12.23 19.5002 12ZM12.0402 15.5C10.1102 15.5 8.54015 13.93 8.54015 12C8.54015 10.07 10.1102 8.5 12.0402 8.5C13.9702 8.5 15.5402 10.07 15.5402 12C15.5402 13.93 13.9702 15.5 12.0402 15.5Z",
    fill: "#121212"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsIcon);
export default __webpack_public_path__ + "static/media/settings-icon.8434793d96c1aa63b112fb80115b07d3.svg";
export { ForwardRef as ReactComponent };